import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Fa from 'react-fontawesome';
import ReactDOM from 'react-dom';
import { filter, truncate } from 'lodash';
import { MenuItem, Button, Overlay } from 'react-bootstrap';

import { getSavedSearches } from '../search-form/search-form-reducer';
import styles from './styles.css';

function InnerPopover({ children, className, style }) {
  return (
    <div className={`${styles.menuPopover} ${className}`} style={style}>
      {children}
    </div>
  );
}
InnerPopover.propTypes = {
  children: PropTypes.element,
  className: PropTypes.string,
  style: PropTypes.shape({}),
};
InnerPopover.defaultProps = {
  className: null,
  children: null,
  style: {},
};


class RunTestRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    this.handleToggle = this.handleToggle.bind(this);
    this.getTarget = this.getTarget.bind(this);
    this.requestRunTest = this.requestRunTest.bind(this);
  }

  getTarget() {
    return ReactDOM.findDOMNode(this.target);
  }

  requestRunTest(automation) {
    this.setState({ open: false }, () => {
      this.props.requestRunTest(automation, this.props.data);
    });
  }

  handleToggle() {
    this.setState({ open: !this.state.open });
  }

  renderInner() {
    const {
      savedSearches,
      dropup,
    } = this.props;

    return (
      <div className="clearfix open">
        <ul className={`dropdown-menu ${dropup ? styles.dropup : ''}`}>
          {savedSearches.map((savedSearch) => {
            return (
              <MenuItem key={savedSearch._id} onClick={() => { this.requestRunTest(savedSearch); }}><Fa name="star" className={savedSearch.is_system ? 'text-warning' : 'invisible'} /> {truncate(savedSearch.automation_name, 30)}</MenuItem>
            );
          })}
        </ul>
      </div>
    );
  }

  renderDropDown() {
    const { dropup, label } = this.props;
    const { open } = this.state;
    
    
    return (
      <div style={{ position: 'relative' }}>
        <Button
          ref={(target) => {
            this.target = target;
          }}
          bsStyle="default"
          bsSize="xs"
          onClick={this.handleToggle}
        >
          {label} <Fa name="caret-down" />
        </Button>
        <Overlay
          show={open}
          rootClose
          onHide={() => this.setState({ open: false })}
          placement={dropup ? 'top' : 'bottom'}
          target={this.getTarget}
        >
          <InnerPopover>
            {this.renderInner()}
          </InnerPopover>
        </Overlay>
      </div>
    );
  }

  render() {
    const { data, savedSearches, label } = this.props;
    if (data === null) {
      return null;
    }
    if (!savedSearches || savedSearches.length === 0) {

    }

    if (savedSearches.length > 1) {
      return this.renderDropDown();
    }

    return (
      <Button
        bsStyle="link"
        bsSize="xs"
        onClick={() => {
          this.requestRunTest(savedSearches[0]);
        }}
      >
        {label}
      </Button>
    );
  }
}

RunTestRenderer.propTypes = {
  data: PropTypes.shape({
    opportunity_id: PropTypes.string,
  }),
  automations: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string,
    automation_name: PropTypes.string, 
    is_system: PropTypes.bool,
  })),
  dropup: PropTypes.bool,
  label: PropTypes.string,
  requestRunTest: PropTypes.func,
};
RunTestRenderer.defaultProps = {
  data: null,
  savedSearches: [],
  dropup: false,
  label: 'Run Test',
  requestRunTest: () => {},
};

function mapStateToProps(state) {
  const savedSearches = filter(getSavedSearches('outcomes', state), { is_automation: true, source: 'opportunity' });
  return {
    savedSearches,
  };
}
export default connect(mapStateToProps, null, null, { forwardRef: true })(RunTestRenderer);
